import React from "react";
import {
  TextWithIconButtonPresenter,
  PresenterProps,
} from "./TextWithIconButton";

type Props = PresenterProps;

export const TextWithIconButton: React.FC<Props> = (props) => {
  return <TextWithIconButtonPresenter {...props}></TextWithIconButtonPresenter>;
};
